import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setFooterLoaded } from "../../store/store";
import "./Footer.scss";
import FooterTop from "./FooterTop/FooterTop";
import FooterMiddle from "./FooterMiddle/FooterMiddle";
import FooterBottom from "./FooterBottom/FooterBottom";
import { useGetThemeOptionsQuery } from "../../services/themeApi";

const Footer = () => {
    const dispatch = useDispatch();
    const { data: themeOptions, isLoading, isError } = useGetThemeOptionsQuery();

    useEffect(() => {
        if (!isLoading && !isError) {
            dispatch(setFooterLoaded());
        }
    }, [isLoading, isError, dispatch]);

    if (isLoading || isError) {
        return null; // Globalny loader kontroluje widoczność
    }

    return (
        <>
            <FooterTop themeOptions={themeOptions} />
            <FooterMiddle themeOptions={themeOptions} />
            <FooterBottom themeOptions={themeOptions} />
        </>
    );
};

export default Footer;
